import { Injectable } from '@angular/core';
import { KnsSnackbarService } from '@kns-jasfbg/kns-snackbar';
import { TranslateService } from '@ngx-translate/core';
import { OAuthInfoEvent, OAuthService } from 'angular-oauth2-oidc';
import { timer } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private oauthService: OAuthService, private translate: TranslateService, private snackbar: KnsSnackbarService) { }

  public logoutOnTokenExpired(): void {
    var tokenExpired = this.oauthService.events.pipe(
      filter((ev: OAuthInfoEvent) => ev.type === "token_refresh_error"),
      mergeMap(_ => this.translate.get('session-expired')),
      mergeMap(sessionExpiredMessage => {
        this.snackbar.openInfo({message:sessionExpiredMessage, closeButton:true, duration: environment.authConfig.expiredTokenLogoutDelayInMs, verticalPosition: 'top'});
        return timer(environment.authConfig.expiredTokenLogoutDelayInMs);
      })
    );

    tokenExpired.subscribe(_ => {
      this.oauthService.logOut();
    })
  }
}
